var router = require('pjax').Router;
var form = require('./form.js');
var index = require('./index.js');

router.get('round/add', form);
router.get('round/:any', form);
router.get('round', index);
